import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_RESIDENTIAL_HISTORY,
  UPDATE_LOAN_SUMMARY_SUCCESS,
  RESIDENTIAL_HISTORY_CHANGED,
  UPDATE_PROFILE_FAILURE,
  LOAN_APPLICATION_USER_VERIFY_FAILURE,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
} from './../../actions/types'

const byId = (state = {}, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.residentialHistories != undefined) {
        return payload.applicationFlow.residentialHistories
      } else {
        return state
      }
    case RESIDENTIAL_HISTORY_CHANGED:
      const {key} = payload
      const updatedResidentialHistory = {...state[key], ...payload }
      return { ...state, [key]: updatedResidentialHistory }
    case BUILD_RESIDENTIAL_HISTORY:
      return {
        ...state,
        [payload.key]: { ...payload.data, errors: {}, years: '0', months: '0' }
      }
    case UPDATE_PROFILE_FAILURE:
    case LOAN_APPLICATION_USER_VERIFY_FAILURE:
      return payload.residentialHistories || {}

    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_SUMMARY_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
      if (payload.residentialHistories !== undefined) {
        return payload.residentialHistories || {}
      } else {
        return state
      }
    default:
      return state;
  }
}

export default byId;
